export default [
    {
        comment: '',
        error_id: 'OP 01',
        data: [
            {cross_section: '4420', profile: 'FW'},
            {cross_section: '4550', profile: 'FW'},
            {cross_section: '5505', profile: '100yr (1%)'},
        ]
    },
]